<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :actionButtons="[]"
    :title="$t('menu.dataAnalysis')"
    :onFetchData="onFetchData"
    ref="sourcePage"
    resource="product_design_analyses"
  >
    <template v-slot:action>
      <el-button type="primary" @click="() => exportClick(selection)">导出</el-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { columnsExtend, filterColumnsExtend } from '../admin_grapes/product_designs.js';
import { getLabel } from '@/custom_form_columns_extend';

@Component
export default class ProductDesignDesignerAnalyses extends Vue {
  @Prop(String) type;

  async onFetchData() {
    const data = await this.$request.get('product_designs/designer_analyses', { params: { ...this.$route.query } });
    return {
      data
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        prop: 'date_range',
        label: '时间范围',
        renderCell: {
          component: 'el-date-picker',
          props: {
            type: 'daterange',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {
              shortcuts: [
                {
                  text: '今天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '昨天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24);
                    end.setTime(end.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近7天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近15天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近30天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                  }
                }
              ]
            }
          }
        }
      },
      {
        key: 'designer_id_eq',
        renderCell: {
          component: 'select',
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('users/read_options', { per_page: 100, role_in: ['designer', 'salesman'] });
              return data.map(object => ({ value: object.id, label: getLabel({ item: object, v: { extra: { model_name: 'User' } } }) }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('users/read_options', { keyword, role_in: ['designer', 'salesman'] });
              return data.map(object => ({ value: object.id, label: getLabel({ item: object, v: { extra: { model_name: 'User' } } }) }));
            }
          },
        }
      },
      'design_type_eq'
    ].filter(Boolean)

    return filterColumnsExtend(array);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns() {
    const sharedColumns = [
      { prop: 'count', label: '总款式' },
      { prop: 'overdue_count', label: '逾期款式' },
      { prop: 'avg_overdue_days', label: '平均逾期天数' },
      { prop: 'reject_count', label: '制单被拒绝款式数' },
      { prop: 'total_reject_count', label: '制单被拒绝次数' },
      {
        prop: 'transaction_rate',
        label: '成交率',
        renderCell: (h, { props: { value } }) => {
          return <span>{(value * 100).toFixed(2)}%</span>
        }
      },
    ]

    const array = [
      {
        prop: 'designer_name',
        label: '设计师/销售员',
      },
      {
        prop: 'product_designs',
        label: '明细',
        type: 'expand',
        width: 80,
        renderCell: (h, { props: { value } }) => {
          const columns = columnsExtend([
            {
              prop: 'date',
              label: '时间',
              width: 100
            },
            ...sharedColumns
          ])
          return <bean-table value={value} columns={columns} height={null} actions={[]} />;
        }
      },
      ...sharedColumns
    ].filter(Boolean)

    return columnsExtend(array);
  }


  async exportClick() {
    await this.$request.get('/product_designs/export_designer_analyses', { ...this.$route.query });
    this.$message.success('文件正在导出，导出成功后将会发送到邮箱');
  }
}

export const route = [
  {
    path: '/product_design_designer_analyses',
    name: 'product_design_designer_analyses.index',
    component: ProductDesignDesignerAnalyses,
    props: {
      type: 'index',
    }
  },
]
</script>
